import ReactGA from 'react-ga'

const trackPage = (page) => {
  ReactGA.pageview(page)
}

let currentPage = ''

export default store => next => action => {
  if (action.type === '@@router/LOCATION_CHANGE') {
    const nextPage = `${action.payload.location.pathname}${action.payload.location.search}`

    if (currentPage !== nextPage) {
      currentPage = nextPage
      trackPage(nextPage)
    }
  }

  return next(action)
}